// Texty homepage (homepage.js). Konkrétní obsah hero karet, bento bannerů
// a řady „Rady a návody" (produkty, ceny, titulky článků, media) zůstává jako
// DATA přímo v modulu — je to redakční/kampaňový obsah vázaný na konkrétní
// produkty a akce, ne obecný UI text (viz komentáře u HERO/BENTO/ARTICLES
// v homepage.js). Sem patří jen strukturální popisky a věty, které modul
// skládá kolem admin/indexových dat.
import { number, currency, NBSP } from '../../modules/money.js';

// „…s dopravou od X" v H1 podtitulu — částka je DATA (práh dopravy zdarma se
// mění, viz shippingModel.js), ale formát (pořadí symbolu, mezera) se má řídit
// jazykem shopu jako všude jinde.
function amountText(n) {
  const c = currency();
  const v = number(n);
  return c.left ? c.symbol + v : v + ' ' + c.symbol;
}

export default {
  hero: {
    label: 'Akční nabídky',
    next: 'Další nabídky',
    dotPrefix: 'Přejít na nabídku ',
  },
  intro: {
    title: 'Kvalitní nářadí, autodoplňky a zahradní technika',
    subBefore: 'Za ',
    subAccent: 'nejlepší ceny',
    /** „ na českém trhu, skladem a s dopravou od 69 Kč." */
    subAfter: (shipFrom) => ' na českém trhu, skladem a s dopravou od ' + amountText(shipFrom) + '.',
  },
  row: {
    leadSub: 'Nejčastěji kupované u nás',
    all: 'Zobrazit vše',
    prev: 'Předchozí produkty',
    next: 'Další produkty',
  },
  sale: {
    eyebrow: 'Zlevněno, jen do vyprodání zásob',
    cdLabel: 'Platnost nabídek končí za',
    cdUnits: ['dny', 'hod', 'min', 'sek'],
    /** „Všech 12 zlevněných produktů" */
    ctaWithCount: (n) => 'Všech ' + n + ' zlevněných produktů',
    ctaPlain: 'Zobrazit všechny zlevněné produkty',
  },
  bento: {
    b2b: {
      eyebrow: 'Pro firmy a řemeslníky',
      title: 'B2B spolupráce až −15' + NBSP + '%',
      text: 'Velkoobchodní ceny na veškerý sortiment. Registrujte firmu a nakupujte výhodněji.',
      cta: 'Registrace firmy',
    },
    sale: {
      title: 'Slevy až −40 % v kategorii Slevoakce',
      text: 'Zlevněné zboží skladem, jen do vyprodání zásob.',
      cta: 'Zjistit více',
    },
  },
  articles: {
    title: 'Rady a návody',
    all: 'Všechny články',
  },
  about: {
    eyebrow: 'O nás',
    title: 'Protože nářadí musí hlavně vydržet.',
    ctaLabel: 'O prodejně',
    badgeTitle: 'Prodejna & servis',
  },
  // Regexy, kterými modul čte NÁZEV ŘADY/KATEGORIE z admin dat Shoptetu (ne
  // vlastní UI text) — SK ekvivalent nebyl možné ověřit proti reálné admin
  // datové sadě (dev/sk fixtures nesou jen dočasnou CZ vrstvu khoder-*, viz
  // CLAUDE.md), proto komentář u každého.
  rowLinkSale: /slevoakce/i, // SK: neověřeno ve fixtures
  rowLinkClearance: /výprodej|vyprodej/i, // SK: neověřeno ve fixtures
  leadRowMatch: /nejobl[ií]ben|nejprod[áa]van/i, // SK: neověřeno ve fixtures
  saleMatch: /slevoakce/i, // SK: neověřeno ve fixtures
  // „34 produktů" na konci textu admin banneru — tvar „produktov" ověřen na
  // nativních SK listingech (dev/sk/category.html, brand.html, search.html:
  // „10 produktov"), stejný číslovkový vzorec platformy.
  catCountRe: new RegExp(
    "[ " + NBSP + "]*[·|,–-]?[ " + NBSP + "]*([0-9][0-9 " + NBSP + "]*)[ " + NBSP + "]+(produkt|produkty|produktů)[ " + NBSP + "]*$",
    'i'
  ),
};
